export default "__VITE_ASSET__DpssT5T5__"